module.exports = __webpack_public_path__ + "img/shrines-1-1440.f599805e.jpg";